export const notEmptyObject = (obj = {}) => {
  return Object.keys(obj).length;
};
